// extracted by mini-css-extract-plugin
export default {"completed":"ConfigurePreview_completed__Av-Iu"};